// extracted by mini-css-extract-plugin
export default {"key":"Keys_key__xhYl+","keys":"Keys_keys__-Cxxp","grey-key":"Keys_grey-key__+2q-9","orange-key":"Keys_orange-key__IVhsW","zero":"Keys_zero__X9zmt"};